import { isNotFoundError } from '@prenuvo/pulse';
import { QueryClient } from '@tanstack/react-query';

import { api } from '@/api';
import { loadPatient } from '@/shared/loader';

async function createBloodReport(carePlanId: string) {
  const postBloodReport = await api.bloodReport.request.postBloodReport({
    payload: { body: { carePlanId } },
  });

  await api.bloodReport.request.postBloodReportAiGenerate({
    payload: { params: { report: { bloodReportId: postBloodReport.bloodReportId } } },
  });

  const bloodReport = await api.bloodReport.request.getBloodReportMetadata({
    payload: { params: { care_plan_id: carePlanId } },
  });

  return bloodReport;
}

async function getOrCreateBloodReport(carePlanId: string) {
  try {
    return await api.bloodReport.request.getBloodReportMetadata({
      payload: { params: { care_plan_id: carePlanId } },
    });
  } catch (error) {
    if (!isNotFoundError(error)) {
      throw error;
    }
  }

  return createBloodReport(carePlanId);
}

export async function loadBloodReportCoreData(queryClient: QueryClient, carePlanId: string) {
  const bloodReport = await queryClient.ensureQueryData({
    queryFn: () => getOrCreateBloodReport(carePlanId),
    queryKey: [api.bloodReport.KEY.GET_BLOOD_REPORT_METADATA, carePlanId],
  });

  const patient = await loadPatient(bloodReport, queryClient);

  return { bloodReport, patient };
}
